import {
    ButtonFixedFooterLayout,
    ButtonPrimary,
    PasswordField,
    Text3,
    skinVars,
    Callout,
    IconInformationUserRegular,
    useDialog,
    IconPowerRegular,
    useWindowSize,
    Text1,
} from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { updateCustomerPassword } from '../../../services/CustomerService';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { AxiosError, AxiosResponse } from 'axios';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import useUserlight from '../../../utils/hooks/useUserLight';
import SnackbarMessage from '../../../components/SnackbarMessage';
import HeaderProfile from '../../../components/HeaderProfile';

export const UpdatePassword: React.FC = () => {
    const { t } = useTranslation();
    const isLight = useUserlight();
    const navigate = useNavigate();
    sessionStorage.removeItem('pathOrigin');
    const { trackingScreenView } = new TrackingEvents();
    const [password, setPassword] = useState('');
    const size = useWindowSize();

    const { dialog } = useDialog();

    const handleNavigate = (url: string, description: string, err?: any) => {
        navigate(url, {
            state: {
                stateFeedback: description,
                err: err,
            },
        });
    };

    const saveNewPassword = () => {
        updateCustomerPassword(password)
            .then((response: AxiosResponse) => {
                if (response) {
                    dialog({
                        icon: <IconPowerRegular color={skinVars.colors.brand} size={40} />,
                        title: t('titleModalLogoutChangePassword'),
                        message: t('subtitleModalLogoutChangePassword'),
                        acceptText: t('buttonModalLogoutChangePassword'),
                        onAccept: () => navigate('/logout'),
                    });
                }
            })
            .catch((error: AxiosError) => {
                const { id, httpCode } = setInfoError(error);
                if (httpCode !== 401 && id !== 'X401502') {
                    handleNavigate('/profile/update-password/feedback', 'ERROR', setInfoError(error));
                }
            });
    };

    const checkPasswordValidation = (password: any) => {
        const specialChars = /^[\x21-\x7EñÑ]{8,20}$/;
        return specialChars.test(password);
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    if (isLight) {
        return <SnackbarMessage url='/profile' timeout={3000} />;
    }

    return (
        <div className='updatePassword-page'>
            <HeaderProfile
                title={t('profileChangePassword')}
                breadcrumbs={[{ title: t('profileTitle'), url: '/profile' }]}
            />
            <div className='updatePassword-page__content'>
                {size.width >= 768 ? (
                    <>
                        {size.width >= 1024 && (
                            <div className='updatePassword-page__content-title'>
                                <Text1 medium color={skinVars.colors.textSecondary}>
                                    {t('profileChangePassword').toUpperCase()}
                                </Text1>
                            </div>
                        )}

                        <div className='updatePassword-page__content-label'>
                            <Text3 regular>{t('changesPasswordTitle')}</Text3>
                        </div>
                        <div className='updatePassword-page__content-input'>
                            <form>
                                <PasswordField
                                    fullWidth={size.width >= 1024 ? true : false}
                                    name='newPassword'
                                    label={t('changesPasswordNewPassword')}
                                    helperText={t('changesPasswordHelperTextInfo')}
                                    onChangeValue={setPassword}
                                    error={!checkPasswordValidation(password)}
                                />
                            </form>
                        </div>
                        <div className='updatePassword-page__content-callout'>
                            <Callout
                                icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
                                title={t('calloutTitleRemenberPassword')}
                                description={t('calloutDescriptionRemenberPassword')}
                            ></Callout>
                        </div>
                        <div className='updatePassword-page__content-btn'>
                            <ButtonPrimary disabled={!checkPasswordValidation(password)} onPress={saveNewPassword}>
                                {t('save')}
                            </ButtonPrimary>
                        </div>
                    </>
                ) : (
                    <ButtonFixedFooterLayout
                        button={
                            <ButtonPrimary onPress={saveNewPassword} disabled={!checkPasswordValidation(password)}>
                                {t('save')}
                            </ButtonPrimary>
                        }
                    >
                        <div className='updatePassword-page__content-label'>
                            <Text3 regular>{t('changesPasswordTitle')}</Text3>
                        </div>
                        <div className='updatePassword-page__content-input'>
                            <form>
                                <PasswordField
                                    fullWidth={size.width >= 1024 && size.width < 1220 ? true : false}
                                    name='newPassword'
                                    label={t('changesPasswordNewPassword')}
                                    helperText={t('changesPasswordHelperTextInfo')}
                                    onChangeValue={setPassword}
                                    error={!checkPasswordValidation(password)}
                                />
                            </form>
                        </div>
                        <div className='updatePassword-page__content-callout'>
                            <Callout
                                icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
                                title={t('calloutTitleRemenberPassword')}
                                description={t('calloutDescriptionRemenberPassword')}
                            ></Callout>
                        </div>
                    </ButtonFixedFooterLayout>
                )}
            </div>
        </div>
    );
};

export default UpdatePassword;
